
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...pageUri]",
      function () {
        return require("private-next-pages/[...pageUri].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...pageUri]"])
      });
    }
  